import {  Component, OnDestroy, OnInit  } from '@angular/core';
import {  Router                        } from '@angular/router';
import {  NgbDropdownConfig             } from '@ng-bootstrap/ng-bootstrap';
import {  Subscription                  } from 'rxjs';
import {  MicrosoftAuthService          } from '../../../../../data/service/auth/microsoft-auth.service';
import {  MesaAyudaCrudService          } from '../../../../../data/service/mesa-ayuda-crud.service';
import {  UserService                   } from '../../../../../data/service/user.service';

@Component({
  selector    : 'app-nav-right',
  templateUrl : './nav-right.component.html',
  styleUrls   : ['./nav-right.component.scss'],
  providers   : [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit, OnDestroy
{
  public usuario  : string | null = null;
  public organo   : string | null = null;
  private userInfoSubscription: Subscription | undefined;

  constructor(private _router: Router, private microsoftAuthService: MicrosoftAuthService, private _mesaAyudaCrud: MesaAyudaCrudService, private userService: UserService) { }

  ngOnInit() { 
    this.userInfoSubscription = this.userService.userInfo$.subscribe(info => {
      this.usuario = info.nombre_usuario;
      this.organo = info.organo;
    });
  }

  ngOnDestroy() {
    this.userInfoSubscription?.unsubscribe();
  }
  

  cerrarSesion(): void {
    this.microsoftAuthService.logout();
  }

}
